import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16 0v14",
      stroke: "currentColor",
      strokeWidth: 1.069
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 15H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM8 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H8Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeDasharray: "2 1",
      d: "M6.25 22.75h19.5v-.5H6.25z"
    })]
  }));
};
export default SvgComponent;